import { z } from 'zod';

const MembershipWalletSettlementSchema = z.object({
  membership_id: z.string().uuid(),
  charged_amount: z.coerce.number().finite().nonnegative(),
  new_balance: z.coerce.number().finite().nonnegative(),
  payment_status: z.literal('wallet_paid'),
  status: z.string().min(1),
  idempotent: z.boolean().default(false),
});

export type MembershipWalletSettlement = z.infer<
  typeof MembershipWalletSettlementSchema
>;

export function parseMembershipWalletSettlement(value: unknown) {
  return MembershipWalletSettlementSchema.parse(value);
}

export function canPayMembershipWithWallet({
  isAuthenticated,
  isAuthorizedPayer,
  walletEnabled,
  walletBalance,
  amount,
  alreadyPaidAmount = 0,
}: {
  isAuthenticated: boolean;
  isAuthorizedPayer: boolean;
  walletEnabled: boolean;
  walletBalance: number;
  amount: number;
  alreadyPaidAmount?: number;
}) {
  return (
    isAuthenticated &&
    isAuthorizedPayer &&
    walletEnabled &&
    alreadyPaidAmount === 0 &&
    Number.isFinite(amount) &&
    amount > 0 &&
    Number.isFinite(walletBalance) &&
    walletBalance + 0.00001 >= amount
  );
}
